import styled from "styled-components";

import { media } from "../../../../../styles/media";

export const BranchCardStyles = styled.div`
  width: 31.5%;
  /* 3-up on desktop → 2-up on tablet → 1-up on phone (overrides come after the
     base width so they win regardless of source order). */
  ${media.maxTablet`width: 48%;`}
  ${media.maxMobile`width: 100%;`}

  background: ${({ theme }) => theme.colors.semantic.container.white};
  box-shadow: ${({ theme }) => theme.shadows.card};
  border-radius: ${({ theme }) => theme.radius[12]};
  padding: ${({ theme }) => theme.spacing[20]};

  .topContent {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${({ theme }) => theme.spacing[16]};

    .branchName {
      font-style: normal;
      font-weight: ${({ theme }) => theme.typography.title.t1.weight};
      font-size: ${({ theme }) => theme.typography.title.t1.size};
      line-height: ${({ theme }) => theme.typography.title.t1.lineHeight};
      color: ${({ theme }) => theme.colors.semantic.text.strong};
    }

    .actions {
      display: flex;
      align-items: center;
      gap: ${({ theme }) => theme.spacing[8]};
    }

    .deleteButton:hover path {
      fill: ${({ theme }) => theme.colors.semantic.container.white};
    }
  }

  .branchDetails {
    margin-bottom: ${({ theme }) => theme.spacing[20]};
    display: flex;

    .branchLeftInfo {
      margin-right: ${({ theme }) => theme.spacing[40]};

      .iconAndText {
        display: flex;
        align-items: center;
        margin-bottom: ${({ theme }) => theme.spacing[12]};

        .text {
          font-style: normal;
          font-weight: ${({ theme }) => theme.typography.body.b3.weight};
          font-size: ${({ theme }) => theme.typography.body.b3.size};
          line-height: ${({ theme }) => theme.typography.body.b3.lineHeight};
          color: ${({ theme }) => theme.colors.semantic.text.weak};
          margin-left: ${({ theme }) => theme.spacing[8]};
        }
      }

      .managersLabel {
        font-style: normal;
        font-weight: ${({ theme }) => theme.typography.title.t3.weight};
        font-size: ${({ theme }) => theme.typography.title.t3.size};
        line-height: ${({ theme }) => theme.typography.title.t3.lineHeight};
        color: ${({ theme }) => theme.colors.semantic.text.weak};
        margin-bottom: ${({ theme }) => theme.spacing[8]};
      }

      .managersPlaceholder {
        font-style: normal;
        font-weight: ${({ theme }) => theme.typography.title.t3.weight};
        font-size: ${({ theme }) => theme.typography.title.t3.size};
        line-height: ${({ theme }) => theme.typography.title.t3.lineHeight};
        color: ${({ theme }) => theme.colors.semantic.text.weak};
      }

      .managersList {
        display: flex;
        align-items: center;

        .managersIcon {
          margin-right: ${({ theme }) => theme.spacing[8]};
        }
      }
    }

    .branchRightInfo {
      .managersLabel {
        font-style: normal;
        font-weight: ${({ theme }) => theme.typography.title.t3.weight};
        font-size: ${({ theme }) => theme.typography.title.t3.size};
        line-height: ${({ theme }) => theme.typography.title.t3.lineHeight};
        color: ${({ theme }) => theme.colors.semantic.text.weak};
        margin-bottom: ${({ theme }) => theme.spacing[8]};
      }

      .managersList {
        display: flex;
        align-items: center;

        .managersIcon {
          margin-right: ${({ theme }) => theme.spacing[8]};
        }
      }
    }
  }

  .buttonsContainer {
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[12]};

    .bottomButtons {
      padding: ${({ theme }) => theme.spacing[8]} ${({ theme }) => theme.spacing[12]};
      border-radius: ${({ theme }) => theme.radius[8]};
    }
  }
`;
